<template>
  <div>
    <section id="knowledge-base-search">
      <b-card
        no-body
        class="knowledge-base-bg text-center"
        :style="{backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`}"
      ><br><br>
        <b-card-body class="card-body">
          <h1 class="text-primary">
            IOT Monitoring System
          </h1><br><br>
        </b-card-body>
      </b-card>
    </section>
    <section id="dashboard-analytics">
      <!-- Stats Card Horizontal -->
      <b-row>
        <b-col
          lg="4"
          sm="6"
        >
          <statistic-card-horizontal
            icon="RepeatIcon"
            color="danger"
            values="605/0"
            titles="SITE"
            subtitle="Total / Inactive,"
            link="Click here to see site list"
          />
        </b-col>
        <b-col
          lg="4"
          sm="6"
        >
          <statistic-card-horizontal
            icon="MonitorIcon"
            color="warning"
            values="592/30"
            titles="DEVICES"
            subtitle="Total / Inactive or disconnected"
            link="Click here to see device list"
          />
        </b-col>
        <b-col
          lg="4"
          sm="6"
        >
          <statistic-card-horizontal
            icon="BellIcon"
            color="success"
            values="21604"
            titles="ACTIVE ALARM"
            link="Click here to see alarm log"
          />
        </b-col>
        <b-col
          lg="4"
          sm="6"
        >
          <statistic-card-horizontal
            icon="DatabaseIcon"
            color="blue"
            values="1,458"
            titles="DATABASE SIZE"
            subtitle="In mega byte"
          />
        </b-col>
        <b-col
          lg="4"
          sm="6"
        >
          <statistic-card-horizontal
            icon="WatchIcon"
            values="-"
            color="purple"
            titles="LAST VALUE"
            link="Click here to see device last value"
          />
        </b-col>
        <b-col
          lg="4"
          sm="6"
        >
          <statistic-card-horizontal
            icon="BarChartIcon"
            color="info"
            values="-"
            titles="TREND"
            link="Click here to see device trend"
          />
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BCardText, BInputGroupPrepend } from 'bootstrap-vue'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import StatisticCardWithAreaChart from '@core/components/statistics-cards/StatisticCardWithAreaChart.vue'
import { kFormatter } from '@core/utils/filter'
import AnalyticsCongratulation from './AnalyticsCongratulation.vue'
import AnalyticsAvgSessions from './AnalyticsAvgSessions.vue'
import AnalyticsSupportTracker from './AnalyticsSupportTracker.vue'
import AnalyticsTimeline from './AnalyticsTimeline.vue'
import AnalyticsSalesRadarChart from './AnalyticsSalesRadarChart.vue'
import AnalyticsAppDesign from './AnalyticsAppDesign.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard, BCardBody, BCardText, BInputGroupPrepend,
    StatisticCardHorizontal,
    AnalyticsCongratulation,
    AnalyticsAvgSessions,
    StatisticCardWithAreaChart,
    AnalyticsSupportTracker,
    AnalyticsTimeline,
    AnalyticsSalesRadarChart,
    AnalyticsAppDesign,
  },
  data() {
    return {
      data: {},
    }
  },
  created() {
    // data
    this.data = {
      congratulations: {
        name: 'John',
        saleToday: '57.6',
      },
      subscribersGained: {
        series: [
          {
            name: 'Subscribers',
            data: [28, 40, 36, 52, 38, 60, 55],
          },
        ],
        analyticsData: {
          subscribers: 92600,
        },
      },
      ordersRecevied: {
        series: [
          {
            name: 'Orders',
            data: [10, 15, 8, 15, 7, 12, 8],
          },
        ],
        analyticsData: {
          orders: 38400,
        },
      },
      avgSessions: {
        sessions: 2700,
        lastDays: ['Last 28 Days', 'Last Month', 'Last Year'],
        growth: '+5.2%',
        goal: 100000,
        users: 100000,
        retention: 90,
        duration: 1,
        salesBar: {
          series: [
            {
              name: 'Sessions',
              data: [75, 125, 225, 175, 125, 75, 25],
            },
          ],
        },
      },
      supportTracker: {
        title: 'Support Tracker',
        lastDays: ['Last 28 Days', 'Last Month', 'Last Year'],
        totalTicket: 163,
        newTicket: 29,
        openTicket: 63,
        responseTime: 1,
        supportTrackerRadialBar: {
          series: [83],
        },
      },
      timeline: {
        step1: {
          title: '12 Invoices have been paid',
          subtitle: 'Invoices have been paid to the company.',
          img: require('@/assets/images/icons/json.png'),
          fileName: 'data.json',
          duration: '12 min ago',
        },
        step2: {
          title: 'Client Meeting',
          subtitle: 'Project meeting with john @10:15am',
          avatar: require('@/assets/images/portrait/small/avatar-s-9.jpg'),
          avatarName: 'John Doe (Client)',
          occupation: 'CEO of Infibeam',
          duration: '45 min ago',
        },
        step3: {
          title: 'Create a new project for client',
          subtitle: 'Add files to new design folder',
          duration: '2 day ago',
          avatars: [
            { userImg: require('@/assets/images/portrait/small/avatar-s-9.jpg'), name: 'Billy Hopkins' },
            { userImg: require('@/assets/images/portrait/small/avatar-s-6.jpg'), name: 'Amy Carson' },
            { userImg: require('@/assets/images/portrait/small/avatar-s-8.jpg'), name: 'Brandon Miles' },
            { userImg: require('@/assets/images/portrait/small/avatar-s-7.jpg'), name: 'Daisy Weber' },
            { userImg: require('@/assets/images/portrait/small/avatar-s-20.jpg'), name: 'Jenny Looper' },
          ],
        },
        step4: {
          title: 'Create a new project for client',
          duration: '5 day ago',
          subtitle: 'Add files to new design folder',
        },
      },
      salesChart: {
        series: [
          {
            name: 'Sales',
            data: [90, 50, 86, 40, 100, 20],
          },
          {
            name: 'Visit',
            data: [70, 75, 70, 76, 20, 85],
          },
        ],
      },
      appDesign: {
        date: '03 Sep, 20',
        title: 'App design',
        subtitle: 'You can Find Only Post and Quotes Related to IOS like ipad app design, iphone app design',
        teams: [
          { name: 'Figma', color: 'light-warning' },
          { name: 'Wireframe', color: 'light-primary' },
        ],
        members: [
          { img: require('@/assets/images/portrait/small/avatar-s-9.jpg'), color: 'primary' },
          { text: 'PI', color: 'light-danger' },
          { img: require('@/assets/images/portrait/small/avatar-s-14.jpg'), color: 'primary' },
          { img: require('@/assets/images/portrait/small/avatar-s-7.jpg'), color: 'primary' },
          { text: 'AL', color: 'light-secondary' },
        ],
        planing: [
          { title: 'Due Date', subtitle: '12 Apr, 21' },
          { title: 'Budget', subtitle: '$49251.91' },
          { title: 'Cost', subtitle: '$840.99' },
        ],
      },
    }
    // this.$http.get('/analytics/data')
    //   .then(response => { this.data = response.data })
  },
  methods: {
    kFormatter,
  },
}
</script>
